const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/integrations/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import type { Integration_Keys } from '@/lib/api/types/integrations';
import i18n from '@/lib/translations/i18n';
import type { LoaderData } from '@/lib/types/common';
const integrationsSchema = z.object({
  integration: z.custom<Integration_Keys>().optional(),
  oauthCredentialsId: z.number().optional(),
  integrationId: z.number().optional(),
  github_installation: z.enum(['success', 'error']).optional()
});
export const Route = createFileRoute('/(app)/org/$org/settings/integrations/')({
  validateSearch: zodValidator(integrationsSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: (): LoaderData => ({
    crumb: i18n.t('common.settings.integrations.integrations')
  }),
  staticData: {
    topNav: {
      title: i18n.t('common.settings.integrations.integrations')
    }
  }
});